var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscrean text-center"},[_c('img',{staticStyle:{"width":"150px"},attrs:{"src":require("../assets/logo.png"),"alt":"CCB"}}),_c('div',{staticClass:"mt-4"},[_c('h6',{staticClass:"mb-1"},[_vm._v("Lamentamos o inconveniente")]),_c('p',[_vm._v("Este app não está disponíveis no momento")])])])
}]

export { render, staticRenderFns }